import { NativeDateAdapter } from '@angular/material/core';

/** Formato visual y de entrada dd/MM/yyyy (p. ej. fecha de aplicación de novedad en traslados). */
export class DdMmYyyyDateAdapter extends NativeDateAdapter {
  override parse(value: unknown): Date | null {
    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value;
    }
    if (typeof value === 'string' && value.trim()) {
      const m = value.trim().match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
      if (m) {
        const d = parseInt(m[1], 10);
        const mo = parseInt(m[2], 10) - 1;
        const y = parseInt(m[3], 10);
        const dt = new Date(y, mo, d);
        if (
          dt.getFullYear() === y &&
          dt.getMonth() === mo &&
          dt.getDate() === d
        ) {
          return dt;
        }
      }
    }
    return null;
  }

  override format(date: Date, displayFormat: Object): string {
    const day = this._to2digit(date.getDate());
    const month = this._to2digit(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private _to2digit(n: number): string {
    return ('00' + n).slice(-2);
  }
}

export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const year = date.getFullYear();
    const month = this._to2digit(date.getMonth() + 1);
    const day = this._to2digit(date.getDate());
    return `${year}/${month}/${day}`;
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
}
